export enum AbsenceAllSubTypeEnumeration {
	PSYCHIC = 'illnessMentalIllness',
	BACK = 'illnessBackProblems',
	OTHER = 'illnessOther',
	UNKNOWN = 'illnessUnknown',

	WORK = 'accidentWork',
	FREE_TIME = 'accidentFreeTime',
}
